import {updateRealTimePrice} from '~/actions/QuoteActions';
import {
  getNameCount,
  getNamesAndNumbersSizes,
  getNumberCount
} from '~/selectors/NamesAndNumbersSelectors';
import {
  anchorColorCount,
  getCurrentColorId,
  getStyleSelections
} from '~/selectors/ProductSelectors';
import {updateProductPrintMinimum} from '~/actions/FundraisingActions';
import {getPostalCode, getQuantitiesJs} from '~/selectors/QuoteSelectors';

import isEqual from 'lodash/isEqual';

function stateComparatorFactory(initialState, nextState) {
  return selector => !isEqual(selector(initialState), selector(nextState));
}

export default function realTimePriceUpdater(store) {
  return next => async action => {
    const initialState = store.getState();
    const result = next(action);
    const nextState = store.getState();
    const selectors = [
      anchorColorCount,
      getCurrentColorId,
      getNameCount,
      getNamesAndNumbersSizes,
      getNumberCount,
      getStyleSelections,
      getQuantitiesJs,
      getPostalCode
    ];

    const stateComparator = stateComparatorFactory(initialState, nextState);
    const isColorCountStale = [anchorColorCount].some(stateComparator);
    const isPriceStale = selectors.some(stateComparator);

    if (isColorCountStale) {
      await updateProductPrintMinimum(
        getCurrentColorId(nextState),
        store.dispatch,
        store.getState
      );
    }

    if (isPriceStale) {
      await updateRealTimePrice()(store.dispatch, store.getState);
    }
    return result;
  };
}
